/**
 * Une valeur qui n'arrive qu'après un temps de silence.
 *
 * Sert la recherche dans l'historique (docs/13 §1) : sans elle, « fractions »
 * tapé au clavier produit neuf requêtes, dont huit dont personne n'attend la
 * réponse — et la neuvième peut arriver avant la huitième, si bien que l'écran
 * finirait par afficher le résultat d'une saisie que l'utilisateur a déjà
 * corrigée.
 *
 * Dans `shared/` depuis la relecture de docs/11 : l'autocomplétion du catalogue
 * est le **second** module qui la demande, et le fichier posait lui-même la
 * condition de son déménagement. La règle du dépôt est qu'une chose devient
 * transverse au second appelant, pas au premier qui l'écrit — l'écrire dans le
 * fichier est ce qui a fait que personne n'a eu à s'en souvenir.
 */
import { useEffect, useState } from "react";

export const SEARCH_DEBOUNCE_MS = 300;

export function useDebouncedValue<T>(value: T, delayMs: number = SEARCH_DEBOUNCE_MS): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setSettled(value);
    }, delayMs);
    // Le nettoyage est ce qui fait le débounce : chaque frappe annule le
    // minuteur précédent, et seul le dernier arrive au bout.
    return () => {
      clearTimeout(timer);
    };
  }, [value, delayMs]);

  return settled;
}
